var exports = {
  "Gf": "FriendsListSection.module__sectionTitle___dWxKRG",
  "f5": "FriendsListSection.module__sectionContent___dWxKRG",
  "v2": "FriendsListSection.module__sectionContentWithMargin___dWxKRG",
};

module.exports = exports;
